import React from 'react'
import './LockedIndicator.css'
import { NO_PERMISSION_MESSAGE } from '../Functions/permissions'

// The one lock affordance, shared by sidebar items and page tabs so the two can't drift.
// When the surrounding element already announces the no-permission reason in its own
// aria-label, pass `decorative` so this icon doesn't repeat it to screen readers.
const LockedIndicator = ({ message = NO_PERMISSION_MESSAGE, className = "", decorative = false }) => (
    <i
        className={`fa fa-lock bos-locked-indicator ${className}`.trim()}
        role={decorative ? undefined : "img"}
        aria-hidden={decorative ? "true" : undefined}
        aria-label={decorative ? undefined : message}
        title={message}
    />
)

export default LockedIndicator
